import React from 'react';

import { Control } from 'react-hook-form';

import { Stack, Typography } from '@mui/material';

import { Input } from '~/components/Common/Forms/fields';

interface Props {
  control: Control<any>;
}

export default function TransferDetailsFields({ control }: Props) {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">Important information</Typography>
      <Typography color="text.secondary" variant="body2">
        Optional heading and body shown in checkout when the selected package includes important information (such as
        transfer details). Leave both fields empty to hide the authored warning.
      </Typography>
      <Input
        control={control}
        fullWidth
        helperText="Displayed as bold text in checkout."
        label="Heading"
        name="transfer_details.heading"
      />
      <Input
        control={control}
        fullWidth
        helperText="Displayed as standard body text in checkout."
        label="Body"
        name="transfer_details.body"
        rows={4}
      />
    </Stack>
  );
}
